import React from 'react';

const Languages = (props: { width?: number; height?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 20}
    height={props.height ?? 20}
    viewBox="0 0 20 20"
  >
    <path d="M10.95 3.162c1.163 1.26 1.954 3.392 2.042 5.838h2.99a6.504 6.504 0 0 0-5.032-5.838zM9.551 3a6.636 6.636 0 0 0-.102 0c-1.363 1.005-2.341 3.293-2.44 6h4.983c-.1-2.707-1.078-4.995-2.441-6zm3.437 7c-.107 2.485-.94 4.634-2.148 5.862A6.504 6.504 0 0 0 15.981 10h-2.993zm-1 0H7.012c.119 2.7 1.114 4.972 2.488 5.946 1.374-.974 2.37-3.246 2.488-5.946zM9 2.016V2l.064.012a7.618 7.618 0 0 1 .872 0L10 2v.016a7.5 7.5 0 1 1-1 0zM3.019 10a6.504 6.504 0 0 0 5.141 5.862C6.952 14.634 6.119 12.485 6.012 10H3.019zm0-1h2.99c.087-2.446.878-4.577 2.04-5.838A6.504 6.504 0 0 0 3.02 9z" />
  </svg>
);

export default Languages;
